import { render, staticRenderFns } from "./CompanyInfo.vue?vue&type=template&id=b2ea78fe&scoped=true"
import script from "./CompanyInfo.vue?vue&type=script&lang=js"
export * from "./CompanyInfo.vue?vue&type=script&lang=js"
import style0 from "./CompanyInfo.vue?vue&type=style&index=0&id=b2ea78fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ea78fe",
  null
  
)

export default component.exports